// 50+ NFL Route Concepts split into packs
// Points are RELATIVE yards from origin (0,0)
// x+ is Right, y- is Downfield (North), y+ is Backfield (South)

export const OFFENSE_PACK = {
    id: 'core_offense',
    name: 'NFL Standard Offense',
    version: '1.0',
    categories: ['Quick', 'Intermediate', 'Deep', 'Double Move', 'Screen', 'Backfield'],
    routes: [
        // --- QUICK (0-5 yds) ---
        { id: 'hitch_5', name: 'Hitch (5y)', category: 'Quick', points: [{ x: 0, y: 0 }, { x: 0, y: -5 }], tags: ['stop'] },
        { id: 'slant_3', name: 'Slant (3y)', category: 'Quick', points: [{ x: 0, y: 0 }, { x: 0, y: -3 }, { x: 6, y: -6 }], tags: ['in'] }, // x+ is "In" if on left? No, x is global relative usually. We need a "flip" modifier
        { id: 'quick_out_3', name: 'Quick Out (3y)', category: 'Quick', points: [{ x: 0, y: 0 }, { x: 0, y: -3 }, { x: 5, y: -3 }], tags: ['out'] },
        { id: 'flat', name: 'Flat', category: 'Quick', points: [{ x: 0, y: 0 }, { x: 6, y: -1 }], tags: ['out'] },
        { id: 'whip', name: 'Whip / Pivot', category: 'Quick', points: [{ x: 0, y: 0 }, { x: 0, y: -5 }, { x: 2, y: -3 }, { x: 5, y: -3 }], tags: ['pivot'] },
        { id: 'stick', name: 'Stick (5y)', category: 'Quick', points: [{ x: 0, y: 0 }, { x: 0, y: -5 }, { x: 1, y: -5 }], tags: ['option'] },

        // --- INTERMEDIATE (10-15 yds) ---
        { id: 'dig_10', name: 'Dig / In (10y)', category: 'Intermediate', points: [{ x: 0, y: 0 }, { x: 0, y: -10 }, { x: 6, y: -10 }], tags: ['in'] },
        { id: 'out_10', name: 'Out (10y)', category: 'Intermediate', points: [{ x: 0, y: 0 }, { x: 0, y: -10 }, { x: 6, y: -10 }], tags: ['out'] }, // Handled by flipper
        { id: 'curl_12', name: 'Curl (12y)', category: 'Intermediate', points: [{ x: 0, y: 0 }, { x: 0, y: -12 }, { x: 0, y: -10 }], tags: ['stop'] },
        { id: 'comeback_15', name: 'Comeback (15y)', category: 'Intermediate', points: [{ x: 0, y: 0 }, { x: 0, y: -15 }, { x: 5, y: -12 }], tags: ['out', 'stop'] },
        { id: 'corner_10', name: 'Corner (10y)', category: 'Intermediate', points: [{ x: 0, y: 0 }, { x: 0, y: -10 }, { x: 8, y: -22 }], tags: ['out', 'deep'] },
        { id: 'post_10', name: 'Post (10y)', category: 'Intermediate', points: [{ x: 0, y: 0 }, { x: 0, y: -10 }, { x: 8, y: -25 }], tags: ['in', 'deep'] },
        { id: 'bang_8', name: 'Bang 8', category: 'Intermediate', points: [{ x: 0, y: 0 }, { x: 0, y: -8 }, { x: 3, y: -15 }], tags: ['in', 'glance'] },

        // --- DEEP (15+ yds) ---
        { id: 'go', name: 'Go / Fly', category: 'Deep', points: [{ x: 0, y: 0 }, { x: 0, y: -30 }], tags: ['vert'] },
        { id: 'fade', name: 'Fade', category: 'Deep', points: [{ x: 0, y: 0 }, { x: 0, y: -10 }, { x: 4, y: -25 }], tags: ['vert', 'out'] },
        { id: 'seam', name: 'Seam', category: 'Deep', points: [{ x: 0, y: 0 }, { x: 0, y: -20 }], tags: ['vert'] },
        { id: 'wheel', name: 'Wheel', category: 'Deep', points: [{ x: 0, y: 0 }, { x: 5, y: -1 }, { x: 5, y: -20 }], tags: ['out', 'vert'] },
        { id: 'rail', name: 'Rail', category: 'Deep', points: [{ x: 0, y: 0 }, { x: 2, y: 0 }, { x: 2, y: -20 }], tags: ['vert'] },
        { id: 'dino', name: 'Dino Post', category: 'Deep', points: [{ x: 0, y: 0 }, { x: 0, y: -10 }, { x: 2, y: -12 }, { x: -5, y: -25 }], tags: ['double', 'in'] },

        // --- DOUBLE MOVES ---
        { id: 'sluggo', name: 'Sluggo', category: 'Double Move', points: [{ x: 0, y: 0 }, { x: 0, y: -3 }, { x: 3, y: -5 }, { x: 3, y: -20 }], tags: ['slant', 'go'] },
        { id: 'out_up', name: 'Out & Up', category: 'Double Move', points: [{ x: 0, y: 0 }, { x: 0, y: -8 }, { x: 4, y: -8 }, { x: 4, y: -20 }], tags: ['out', 'go'] },
        { id: 'hitch_go', name: 'Hitch & Go', category: 'Double Move', points: [{ x: 0, y: 0 }, { x: 0, y: -5 }, { x: 0, y: -20 }], tags: ['stop', 'go'] },

        // --- SCREEN ---
        { id: 'bubble', name: 'Bubble', category: 'Screen', points: [{ x: 0, y: 0 }, { x: 5, y: 2 }, { x: 8, y: 2 }], tags: ['screen'] },
        { id: 'tunnel', name: 'Tunnel', category: 'Screen', points: [{ x: 0, y: 0 }, { x: 0, y: -2 }, { x: 5, y: 2 }], tags: ['screen'] },
        { id: 'jailbreak', name: 'Jailbreak', category: 'Screen', points: [{ x: 0, y: 0 }, { x: 0, y: 0 }, { x: 3, y: 1 }], tags: ['screen'] },

        // --- BACKFIELD ---
        { id: 'swing', name: 'Swing', category: 'Backfield', points: [{ x: 0, y: 0 }, { x: 5, y: 2 }, { x: 8, y: -5 }], tags: ['rb'] },
        { id: 'angle', name: 'Angle / Texas', category: 'Backfield', points: [{ x: 0, y: 0 }, { x: 3, y: -2 }, { x: -2, y: -8 }], tags: ['rb', 'in'] },
        { id: 'checkdown', name: 'Checkdown', category: 'Backfield', points: [{ x: 0, y: 0 }, { x: 0, y: -2 }, { x: 2, y: -2 }], tags: ['rb'] },
    ]
};

export const DEFENSE_PACK = {
    id: 'core_defense',
    name: 'NFL Standard Defense',
    version: '1.0',
    categories: ['Coverage', 'Blitz', 'Line'],
    routes: [
        // --- COVERAGE ---
        { id: 'deep_half', name: 'Deep Half', category: 'Coverage', points: [{ x: 0, y: 0 }, { x: 0, y: -18 }], tags: ['zone', 'deep'] },
        { id: 'deep_third', name: 'Deep Third', category: 'Coverage', points: [{ x: 0, y: 0 }, { x: 0, y: -22 }], tags: ['zone', 'deep'] },
        { id: 'hook_curl', name: 'Hook / Curl', category: 'Coverage', points: [{ x: 0, y: 0 }, { x: 0, y: -8 }], tags: ['zone', 'under'] },
        { id: 'flat_zone', name: 'Flat', category: 'Coverage', points: [{ x: 0, y: 0 }, { x: 8, y: -4 }], tags: ['zone', 'flat'] },
        { id: 'robber', name: 'Robber', category: 'Coverage', points: [{ x: 0, y: 0 }, { x: 0, y: -10 }], tags: ['zone', 'middle'] },

        // --- BLITZ ---
        { id: 'blitz_a', name: 'A-Gap Blitz', category: 'Blitz', points: [{ x: 0, y: 0 }, { x: 0, y: 6 }], tags: ['blitz'] },
        { id: 'blitz_edge', name: 'Edge Blitz', category: 'Blitz', points: [{ x: 0, y: 0 }, { x: 4, y: 4 }, { x: 2, y: 8 }], tags: ['blitz'] },
        { id: 'stunt_in', name: 'Stunt In', category: 'Blitz', points: [{ x: 0, y: 0 }, { x: 0, y: 2 }, { x: -3, y: 6 }], tags: ['dl'] },
        { id: 'stunt_out', name: 'Stunt Loop', category: 'Blitz', points: [{ x: 0, y: 0 }, { x: -2, y: 1 }, { x: 4, y: 6 }], tags: ['dl'] },

        // --- LINE ---
        { id: 'contain', name: 'Contain', category: 'Line', points: [{ x: 0, y: 0 }, { x: 2, y: 4 }, { x: 4, y: 4 }], tags: ['dl'] },
        { id: 'spy', name: 'QB Spy', category: 'Line', points: [{ x: 0, y: 0 }, { x: 0, y: -2 }], tags: ['lb'] },
    ]
};

export const createLibrary = () => {
    const packs = [OFFENSE_PACK, DEFENSE_PACK];

    return {
        getPack: (id) => packs.find(p => p.id === id),
        getAllRoutes: () => packs.flatMap(p => p.routes),
        getOffenseRoutes: () => OFFENSE_PACK.routes,
        getDefenseRoutes: () => DEFENSE_PACK.routes
    };
};
